import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { getFinancialSegment, FINANCIAL_SEGMENTS, calculateRiskScore } from '../../shared/risk-helpers';
import styles from './RiskConcernSummary.css';

function RiskConcernSummary({ userResponses = [] }) {
    const segment = getFinancialSegment(userResponses);
    const { label } = FINANCIAL_SEGMENTS[segment];
    const riskCount = calculateRiskScore(userResponses);

    return (
        <div className={styles.root}>
            <div className={styles.item}>
                <Icon name='warningTriangleOutline' className={styles.icon} />
                <div>
                    <p className={styles.label}>Main concern</p>
                    <p className={styles.value}>{label}</p>
                </div>
            </div>
            <div className={styles.divider} />
            <div className={styles.item}>
                <Icon name='shieldCheckOutline' className={styles.icon} />
                <div>
                    <p className={styles.label}>Action strategy</p>
                    <p className={styles.value}>{riskCount} risk fixing</p>
                </div>
            </div>
        </div>
    );
}

RiskConcernSummary.propTypes = {
    userResponses: PropTypes.arrayOf(PropTypes.shape({
        questionId: PropTypes.number,
        segment: PropTypes.string,
        score: PropTypes.number
    }))
};

export {
    RiskConcernSummary
};
